<template>

  <div class="flex justify-center items-start">
    <div class="w-full mx-auto max-w-[885px] flex justify-center items-center rounded-[35px] h-[229px]">
      <template v-if="!loading && slides.length > 0">
        <Swiper class="mySwiper h-full rounded-[35px]" :key="lang || isShorter"
                :autoplay="{ delay: 1500, disableOnInteraction: false }" :modules="modules" :speed="2000" :loop="true" :effect="'fade'"
                :dir="lang === 'ar' ? 'rtl' : 'ltr'">
          <SwiperSlide v-for="(each) in slides" :key="each.id">
            <div class="w-full text-center h-full">
              <img :src="each.imageUrl" class="mx-auto !h-full !w-full object-cover" width="235.15" height="141.1"
                   loading="lazy"
                   alt="slider-logo"/>
            </div>
          </SwiperSlide>
        </Swiper>
      </template>

      <div class="flex items-center justify-center h-full w-full bg-[#E0E9F0] rounded-[35px] border" v-if="!loading && slides.length == 0">
        {{ lang === 'en' ? 'No slides found.' : 'لم يتم العثور على شرائح.' }}
      </div>

      <div class="w-full bg-[#E0E9F0] rounded-[35px] h-full border flex items-center justify-center" v-if="loading">
        <LoaderVue/>
      </div>
    </div>
  </div>

</template>

<script>

import {Swiper, SwiperSlide} from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/effect-fade';
import LoaderVue from "@/components/Loader.vue";
import {Autoplay, EffectFade} from "swiper/modules";
import ApiService from "@/service/apiService";

export default {
  components: {
    LoaderVue,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      lang: window.core.lang,
      slides: [],
      loading: false,
      modules: [ Autoplay, EffectFade],
    }
  },

  props: {
    isShorter: {
      required: true
    },
  },

  methods: {
    async getSlides() {
      try {
        this.loading = true;
        const url = `/store/getSlides`;
        const response = await ApiService.post(url, {});
        this.slides = response.data.data;
        this.slides.forEach((each) => {
          each.imageUrl = `${process.env.VUE_APP_IMAGE_URL}/${each.file_path}`;
        })
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        this.loading = false;
      }
    },
  },


  mounted() {
    this.getSlides();
  },

  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {

    };
    return {
      onSwiper,
      onSlideChange,
    };
  },
}

</script>